import { useForm } from 'react-hook-form'
import { BpButton } from '../../../../shared/components/buttons/bp-button/BpButton'
import { BpInput } from '../../../../shared/components/forms/input/BpInput'
import { FormHTMLAttributes } from 'react'
import { useTranslation } from 'react-i18next'
import { validatePassword } from '../../../../shared/lib/helpers/ValidatePassword'
import styles from './SetUpPasswordForm.module.scss'

export interface ISetUpPasswordFormData {
  password: string
  confirmPassword: string
}

export interface ISetUpPasswordFormProps extends FormHTMLAttributes<HTMLFormElement> {
  submitHandler?: (data: ISetUpPasswordFormData) => void
  isFetching?: boolean
}

export const SetUpPasswordForm = ({
  submitHandler,
  isFetching = false,
  ...formProps
}: ISetUpPasswordFormProps) => {
  const { t } = useTranslation()
  const {
    handleSubmit,
    register,
    getValues,
    formState: { errors, isValid },
  } = useForm<ISetUpPasswordFormData>({
    mode: 'onChange',
    defaultValues: {
      password: '',
      confirmPassword: '',
    },
  })

  return (
    <>
      <h2 className={styles.title}>{t('pages.auth.setUpYourPassword')}</h2>
      <form
        {...formProps}
        className={styles.form}
        onSubmit={handleSubmit((data: ISetUpPasswordFormData) => {
          if (submitHandler) submitHandler(data)
        })}
      >
        <BpInput
          required
          error={errors.password?.message}
          fieldSize='lg'
          label={t('pages.auth.fields.newPassword')}
          type='password'
          {...register('password', {
            required: t('fields.validate.required'),
            validate: (value) => validatePassword(value, t),
          })}
        />
        <BpInput
          required
          error={errors.confirmPassword?.message}
          fieldSize='lg'
          label={t('pages.auth.fields.confirmNewPassword')}
          type='password'
          {...register('confirmPassword', {
            required: t('fields.validate.required'),
            validate: (value: string) => {
              const { password } = getValues()
              return value === password || t('pages.auth.fields.passwordsDoNotMatch')
            },
          })}
        />
        <div className={styles.actions}>
          <BpButton className={styles.submitButton} disabled={!isValid || isFetching} size='lg' type='submit'>
            {t('pages.auth.buttons.confirm')}
          </BpButton>
        </div>
      </form>
    </>
  )
}
